import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LogReaderForm from '../forms/log-reader-form';
import { logReaderValidationSchema } from '../schema/logReader.js';

export default function LogReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Log Reader Node Details',
        altText: 'Log Reader Node',
        defaultLabel: 'Log Reader Node',
      }}
    >
      <CommonNode FormComponent={LogReaderForm} schemaResolver={logReaderValidationSchema} />
    </NodeProvider>
  );
}
